import React from 'react';
import { showToast } from '../../../Utils';

const ConfirmationDialog = ({ title, message, placeholderNote, note, isOpen, onClose, onConfirm, onNoteChange }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-1/3">
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <p className="mb-4">{message}</p>
        {note !== undefined && (
          <textarea
            className="w-full p-2 border rounded mb-4 resize-none"
            placeholder={placeholderNote}
            value={note}
            onChange={onNoteChange}
          />
        )}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded mr-2"
          >
            Batal
          </button>
          <button
            onClick={() => {
              if (note !== undefined && note.trim() === "") {
                showToast("Error", placeholderNote + " harus diisi.");
                return;
              }
              onConfirm();
            }}
            className="px-4 py-2 bg-red-500 text-white rounded"
          >
            Konfirmasi
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
